// frontend/src/components/Hero.jsx
import { useMemo } from "react";
import { uploadsUrl } from "../utils/api";
import "./Hero.css";

function extractYoutubeId(url) {
  if (!url) return null;
  const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:shorts\/|watch\?v=|embed\/))([^?&/]+)/);
  return m ? m[1] : null;
}

export default function Hero({ projectId, header, onCtaClick }) {
  const { projectName, developerName, projectSubheading, startingPrice, siteVisitText,
          youtubeVideoUrl, mobileReelUrl } = header;

  const mobileId  = useMemo(() => extractYoutubeId(mobileReelUrl),  [mobileReelUrl]);
  const desktopId = useMemo(() => extractYoutubeId(youtubeVideoUrl), [youtubeVideoUrl]);
  const hasMedia  = mobileId || desktopId;

  const bgStyle = !hasMedia ? {
    "--bg1": `url('${uploadsUrl(projectId, "background1.webp")}')`,
    "--bg2": `url('${uploadsUrl(projectId, "background2.webp")}')`,
    "--bg3": `url('${uploadsUrl(projectId, "background3.webp")}')`,
  } : {};

  return (
    <>
      <header
        className={`hero-header${!hasMedia ? " no-media" : ""}`}
        style={bgStyle}
        aria-label="Hero section"
      >
        {/* Background media */}
        {hasMedia && (
          <div className="hero-media">
            {mobileId && (
              <iframe
                className="hero-media__iframe hero-media__iframe--mobile"
                src={`https://www.youtube.com/embed/${mobileId}?autoplay=1&mute=1&loop=1&controls=0&playlist=${mobileId}&modestbranding=1&showinfo=0&rel=0`}
                allow="autoplay; fullscreen"
                title="Background reel"
              />
            )}
            {desktopId && (
              <iframe
                className="hero-media__iframe hero-media__iframe--desktop"
                src={`https://www.youtube.com/embed/${desktopId}?autoplay=1&mute=1&loop=1&controls=0&playlist=${desktopId}&modestbranding=1&showinfo=0&rel=0`}
                allow="autoplay; fullscreen"
                title="Background video"
              />
            )}
          </div>
        )}

        {/* Gradient overlay */}
        <div className="hero-overlay" aria-hidden="true" />

        {/* Desktop hero content */}
        <div className="hero-content hero-content--desktop">
          <p className="hero-content__developer">{developerName}</p>
          <h1 className="hero-content__title">{projectName}</h1>
          {projectSubheading && (
            <p className="hero-content__sub">{projectSubheading}</p>
          )}
          <div className="hero-content__actions">
            {startingPrice && (
              <button
                className="hero-btn hero-btn--price"
                onClick={() => document.querySelector(".apartment-section")?.scrollIntoView({ behavior: "smooth" })}
              >
                {startingPrice}
              </button>
            )}
            <button
              className="hero-btn hero-btn--cta"
              onClick={() => onCtaClick("Site Visit")}
            >
              {siteVisitText || "Book Site Visit"}
            </button>
          </div>
        </div>

        {/* Mobile hero bottom overlay */}
        <div className="hero-mobile-bar">
          <div className="hero-mobile-bar__info">
            <h1>{projectName}</h1>
            <h2>📍 {developerName}</h2>
          </div>
          {startingPrice && (
            <button
              className="hero-mobile-bar__price"
              onClick={() => document.querySelector(".apartment-section")?.scrollIntoView({ behavior: "smooth" })}
            >
              {startingPrice}
            </button>
          )}
        </div>
      </header>

      {/* Mobile subheading bar */}
      <div className="hero-subbar">
        {projectSubheading && <h4 className="hero-subbar__text">{projectSubheading}</h4>}
        <button className="btn-primary hero-subbar__btn" onClick={() => onCtaClick("Site Visit")}>
          {siteVisitText || "Book A Free Site Visit"}
        </button>
      </div>
    </>
  );
}
